// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PY7j","placeholdersHeader":"styles_placeholdersHeader__2uOiF","editorStyle":"styles_editorStyle__VPpQQ","placeholdersBox":"styles_placeholdersBox__1DInm"};